import React from 'react'

import { EntryCardPartProps } from './entry-card.d';

import EntryCard from '/react4xp/components/EntryCard'

function EntryCardPart(props: EntryCardPartProps) {
    return (
        <EntryCard {...props} />
    )
}

export default (props) => <EntryCardPart {...props} /> 